module.exports = __webpack_public_path__ + "media/bootstrap-icons/wind-e105dd05.svg";